export default "__VITE_ASSET__917ae588__"